import React from 'react'
import { View } from 'react-native'
import { BottomSheet } from '@src/components'
import { VideoCallsStartContent } from './VideoCallsStartContent'

export const VideoCallsStartModal = () => {
  return (
    <BottomSheet>
      <View>
        <VideoCallsStartContent />
      </View>
    </BottomSheet>
  )
}
